import { DISEASE_SUB_TYPE_QUESTION_ID_BY_DISEASE } from 'modules/questionnaire/constants';

export const getAdditionalParams = (profile) => {
  const { personal, condition_profile } = profile ?? {};

  if (!personal || !condition_profile) {
    return {};
  }

  const diseaseSubTypeField = DISEASE_SUB_TYPE_QUESTION_ID_BY_DISEASE[personal.condition];
  const diseaseSubTypeValue = condition_profile[diseaseSubTypeField];

  return diseaseSubTypeValue ? { diseaseSubTypeField, diseaseSubTypeValue } : {};
};
